import Button from '@atoms/Button.new';
import React from 'react';
import ColorizeRoundedIcon from '@mui/icons-material/ColorizeRounded';
import { useRoSContext } from '@components/Presentation/context/RoSContext';
import { type InteractionType } from '@components/Presentation/types';

type NoPDF = Exclude<
  InteractionType,
  'PDF Slide'
>;

type Title = {
  [key in NoPDF]: string;
};

function ApplyAllOrReset() {
  const { selectedSlide } = useRoSContext();

  const title: Title = {
    pollWithOptions: 'Power Polls',
    freeForm: 'Open-Ended Polls',
    wordCloud: 'Wonder Words',
    map: 'Magic Maps',
    emojisEverywhere: 'Emojis Everywhere',
    talkingTiles: 'Talking Tiles',
    transientThought: 'Transient Thoughts',
    textTrack: 'Text Track',
    newWheel: 'Winning Wheel',
    wheel: 'Choice Circle',
    linkLibrary: 'Link Library',
    'Quick Questions': 'Quick Questions',
    fantasticFans: 'Fantastic Fans',
    ratingPolls: 'Rating Polls',
    multipleChoice: 'Multiple Choice',
  };
  return (
    <div className="flex flex-col items-center gap-6 py-6 px-6 border-t-1 border-grey-200 dark:border-grey-800">
      <Button
        variant="secondary"
        size="lg"
        onClick={selectedSlide.handler.applyToSimilarSlides}
        addonLeft={<ColorizeRoundedIcon fontSize="medium" />}
        fullWidth
      >
        Apply to all {title[selectedSlide.type as NoPDF]}
      </Button>
      <button
        onClick={selectedSlide.handler.resetDesign}
        className="text-sm text-blue-600 w-fit"
      >
        Reset this slide to default
      </button>
    </div>
  );
}

export default ApplyAllOrReset;
